import { FC, useMemo } from "react";
import { NormalizedCostWidgetHighChart } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/NormalizedCostWidgetHighChart";
import { useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupSelector";
import { normalizedCostWidgetSetupDataSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetSetupDataSelector";
import { chartTypeFromRechartToHighCharts } from "@/components/utils/helpers/chartTypeFromRechartToHighCharts";
import { HighchartsChartType } from "@/storybook/c8r-highcharts/common/components/HighchartsChartTypeSelect";
import { normalizedCostWidgetSetupDataLoadingSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetSetupDataLoadingSelector";

export const NormalizedCostWidgetSetupChartView: FC = () => {
  const setup = useAppSelector(normalizedCostWidgetSetupSelector);
  const data = useAppSelector(normalizedCostWidgetSetupDataSelector);
  const loading = useAppSelector(normalizedCostWidgetSetupDataLoadingSelector);

  const hasAggregation = useMemo(
    () =>
      Object.values(setup?.aggregation ?? {}).some(
        (aggregation) => aggregation,
      ),
    [setup?.aggregation],
  );

  return (
    <NormalizedCostWidgetHighChart
      chartType={
        chartTypeFromRechartToHighCharts(
          setup?.visualization.chart_type ?? "line",
        ) as HighchartsChartType
      }
      loading={loading}
      regular={data?.regular_cost}
      normalized={data?.normalized}
      hasAggregations={hasAggregation}
      scale={setup?.visualization?.scale}
      showLegends={setup?.visualization?.show_legends}
    />
  );
};
